module.exports = __webpack_public_path__ + "img/full3-min.bb1d43ba.png";